var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBooleanField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_26768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54548 13.1371C9.13997 13.5451 8.47777 13.5451 8.07227 13.1371L5.69131 10.7412C5.28469 10.3332 5.28469 9.66684 5.69131 9.2588C6.09682 8.85076 6.75902 8.85076 7.16453 9.2588L8.80887 10.9134L12.8342 6.86297C13.2397 6.45493 13.9019 6.45493 14.3074 6.86297C14.7129 7.27101 14.7129 7.93735 14.3074 8.34539L9.54548 13.1371ZM1.66602 4.01043C1.66602 2.6871 2.73186 1.61459 4.04697 1.61459H15.9517C17.265 1.61459 18.3327 2.6871 18.3327 4.01043V15.9896C18.3327 17.311 17.265 18.3854 15.9517 18.3854H4.04697C2.73186 18.3854 1.66602 17.311 1.66602 15.9896V4.01043ZM3.45173 4.01043V15.9896C3.45173 16.319 3.7181 16.5886 4.04697 16.5886H15.9517C16.2791 16.5886 16.547 16.319 16.547 15.9896V4.01043C16.547 3.6795 16.2791 3.41147 15.9517 3.41147H4.04697C3.7181 3.41147 3.45173 3.6795 3.45173 4.01043Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_26768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 19.1667,
    fill: "white",
    transform: "translate(1.66602 0.416672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooleanField);
export default __webpack_public_path__ + "static/media/boolean-field.22a463b84221992dfe8f493e4eeaf423.svg";
export { ForwardRef as ReactComponent };